module.exports = {"220402001":"东吉街道","220402002":"南康街道","220402003":"北寿街道","220402004":"西宁街道","220402005":"站前街道","220402006":"向阳街道","220402007":"新兴街道","220402008":"福镇街道","220402070":"辽源经济开发区特殊街道","220402100":"寿山镇","220402200":"工农乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220402.json
// module id = 724
// module chunks = 0